import { cva } from 'class-variance-authority'

export const kpiCardVariants = cva('flex rounded-lg border border-main-border-default', {
  variants: {
    appearance: {
      kpi: 'bg-transparent',
      metric: 'bg-main-background-card',
    },
    variant: {
      default: 'text-main-foreground-primary',
      danger: 'text-main-foreground-danger',
    },
    orientation: {
      stacked: 'flex-col gap-1 p-4',
      leading: 'min-w-52 flex-row items-center gap-3 p-3',
    },
    interactive: {
      true: 'cursor-pointer transition-all hover:border-main-border-semiBold',
      false: '',
    },
  },
  compoundVariants: [
    { appearance: 'kpi', orientation: 'stacked', class: 'min-w-[172px] flex-1' },
    { appearance: 'metric', orientation: 'stacked', class: 'min-w-32' },
  ],
  defaultVariants: {
    appearance: 'kpi',
    variant: 'default',
    orientation: 'stacked',
    interactive: false,
  },
})

export const kpiLabelVariants = cva('', {
  variants: {
    compact: { true: 'text-label-small', false: 'text-label-default' },
  },
  defaultVariants: { compact: false },
})
